// react
import styled, { css } from 'styled-components';

// mux
import MuxPlayer from '@mux/mux-player-react';

// models
import { ReferralFormType } from '@karehero/models';

// components
import { CareReferralInfo } from '@/pwa/organisms/CareReferralInfo/CareReferralInfo';
import { ReferralProcess } from '@/components/molecules/ReferralProcess/ReferralProcess';
import { PageTemplate } from '@/pwa/templates/PageTemplate/PageTemplate';
import { Logo } from '@/components/atoms/Logo/Logo';

// mui
import {
  Card,
  CardContent,
  CardMedia,
  Container,
  Stack,
  Typography,
} from '@mui/material';

// assets
// @transform-path ../../../../../../src/assets/referral/header.jpg
import headerImage from '@/assets/referral/header.jpg';

/**
 * CareConciergeReferral renders the referral landing page.
 */
export const CareConciergeReferral = ({
  onRegister,
  onSignIn,
  videoPlaybackID,
  videoThumbnailTime = 14,
}: CareConciergeReferralProps) => {
  return (
    <PageTemplate
      maxWidth='sm'
      contentSlot={
        <Stack
          sx={{
            gap: 4,
          }}
        >
          <Stack
            sx={{
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Logo size='md' />
            <Typography variant='h5'>Care Simplified.</Typography>
          </Stack>
          <Card elevation={2}>
            <CardMedia
              component='img'
              image={String(
                typeof headerImage === 'string'
                  ? headerImage
                  : (headerImage as any).src,
              )}
              alt='Care concierge referral'
            />
            <CardContent>
              <CareReferralInfo onRegister={onRegister} onSignIn={onSignIn} />
            </CardContent>
          </Card>
          <Card elevation={2}>
            <CardContent>
              <Stack
                sx={{
                  gap: 4,
                }}
              >
                <ReferralProcess formType={ReferralFormType.SjpIFA} />
                {videoPlaybackID && (
                  <Stack
                    sx={{
                      gap: 2,
                    }}
                  >
                    <StyledMuxPlayer
                      playbackId={videoPlaybackID}
                      thumbnailTime={videoThumbnailTime}
                    />
                  </Stack>
                )}
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      }
    />
  );
};

// styles
const StyledMuxPlayer = styled(MuxPlayer)`
  border-radius: 8px;
  overflow: hidden;
  ${(props) =>
    props.theme.breakpoint.md(css`
      margin: auto;
      max-width: 100%;
    `)}
`;

// types
interface CareConciergeReferralProps {
  onRegister: () => void;
  onSignIn: () => void;
  videoPlaybackID?: string;
  videoThumbnailTime?: number;
}

CareConciergeReferral.displayName = 'CareConciergeReferral';

export default CareConciergeReferral;
